import ContentItem from '../api/content/ContentItem';
import { ItemSource } from '@kollective-frontend/ksdk-api';

export default function contentItemsToItemSources(
  items?: ContentItem[]
): ItemSource[] {
  if (!items) {
    return [] as ItemSource[];
  }
  return items.reduce((acc, item) => {
    if (item.url) {
      acc.push({
        src: item.url,
        type: item.data && item.data.mime
      });
    }
    return acc;
  }, [] as ItemSource[]);
}
